import dayjs from "dayjs";
import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  input,
  viewChild,
  output
} from "@angular/core";
import { IDateRange } from "../../../../../core-ui/models/interfaces";
import {
  DayTimeCalendarComponent,
  IDate,
  IDatePickerConfig,
} from "ng2-date-picker";

@Component({
  selector: "app-date-range-picker-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.scss"],
  standalone: false,
})
export class DateRangePickerPopupComponent
  implements OnInit, AfterViewInit
{
  @Input()
  set startDate(value: dayjs.Dayjs) {
    this._startDate = value;
    this.dpStartAt = dayjs(value.toDate());
  }
  get startDate() {
    return this._startDate;
  }
  @Input()
  set endDate(value: dayjs.Dayjs) {
    this._endDate = value;
    this.dpEndAt = dayjs(value.toDate());
  }
  get endDate() {
    return this._endDate;
  }
  readonly direction = input<"row" | "column" | "responsive">("row");

  readonly closed = output<void>();
  readonly rangeChanged = output<IDateRange>();

  readonly startCalendarRef = viewChild<DayTimeCalendarComponent>("startPicker");
  readonly endCalendarRef = viewChild<DayTimeCalendarComponent>("endPicker");

  dateConfig: IDatePickerConfig = {
    format: "YYYY-MM-DD",
    firstDayOfWeek: "mo",
  };

  rangeToday: IDateRange = {
    startAt: this.startOfDay(dayjs()),
    endAt: this.endOfDay(dayjs()),
  };
  rangeYesterday: IDateRange = {
    startAt: this.startOfDay(dayjs().subtract(1, "days")),
    endAt: this.endOfDay(dayjs().subtract(1, "days")),
  };
  rangeThisWeek: IDateRange = {
    startAt: this.startOfDay(dayjs().day(1)),
    endAt: this.endOfDay(dayjs().set("hours", 23)),
  };
  rangeLastWeek: IDateRange = {
    startAt: this.startOfDay(dayjs().day(-6)),
    endAt: this.endOfDay(dayjs().day(0)),
  };
  rangeThisMonth: IDateRange = {
    startAt: this.startOfDay(dayjs().date(1)),
    endAt: this.endOfDay(dayjs()),
  };
  rangeLastMonth: IDateRange = {
    startAt: this.startOfDay(dayjs().subtract(1, "months").date(1)),
    endAt: this.endOfDay(
      this.startOfDay(dayjs().date(1)).subtract(1, "seconds")
    ),
  };
  _startDate: dayjs.Dayjs;
  _endDate: dayjs.Dayjs;
  dpStartAt: dayjs.Dayjs;
  dpEndAt: dayjs.Dayjs;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.startCalendarRef().api.moveCalendarTo(this.startDate);
    this.endCalendarRef().api.moveCalendarTo(this.endDate);
  }

  closeRequest() {
    this.closed.emit();
  }

  startOfDay(day: dayjs.Dayjs): dayjs.Dayjs {
    return day.set("hours", 0).set("minutes", 0).set("seconds", 0);
  }

  endOfDay(day: dayjs.Dayjs): dayjs.Dayjs {
    return day.set("hours", 23).set("minutes", 59).set("seconds", 59);
  }

  get arrowPos() {
    return this.direction() === "column" ? "top-left" : "top";
  }

  startChange(entry: IDate) {
    if (!entry) {
      return;
    }
    this._startDate = dayjs(entry.date.toDate());
    this.rangeChanged.emit({
      startAt: this.startDate,
      endAt: this.endDate,
    });
  }

  endChange(entry: IDate) {
    if (!entry) {
      return;
    }
    this._endDate = dayjs(entry.date.toDate());
    this.rangeChanged.emit({
      startAt: this.startDate,
      endAt: this.endDate,
    });
  }

  rangeChange(range: IDateRange) {
    this.startCalendarRef().api.moveCalendarTo(range.startAt);
    this.endCalendarRef().api.moveCalendarTo(range.endAt);
    this.rangeChanged.emit(range);
  }
}
